const language = {
	spanish: {
		linkedin_text: "Encuéntranos en LinkedIn",
		copyright_text: "Copyright © 2021. ForesightGPS.",
		copyright_span: "Política de Privacidad.",
		acerca_title: "Acerca Foresight GPS:",
		acerca_link_1: "Quiénes Somos",
		acerca_link_2: "Carreras",
		acerca_link_3: "Noticias",
		acerca_link_4: "Casos de Estudio",
		recursos_title: "Recursos y Contacto:",
		recursos_link_1: "Centro de Soporte",
		recursos_link_2: "Preguntas Frecuentes",
		recursos_link_3: "Tutoriales",
		recursos_link_4: "Contacto",
		servicios_title: "Servicios para:",
		servicios_link_1: "Industrias y Empresas",
		servicios_link_2: "Familiares e Individuales",
		soluciones_title: "Soluciones:",
		soluciones_link_1: "G-Evolution",
		soluciones_link_2: "Mobile Apps",
		soluciones_link_3: "Telemática IoT",
		soluciones_link_4: "Servicios",
		oficinas_title: "Oficinas:",
		mapa_text: "Ver mapa",
		// button_1_text: "SOLICITE UN DEMO",
		button_2_text: "centro de soporte",
	},
	english: {
		linkedin_text: "Find us on LinkedIn",
		copyright_text: "Copyright © 2021. ForesightGPS.",
		copyright_span: "Privacy Policy.",
		acerca_title: "About Foresight GPS:",
		acerca_link_1: "Who we are",
		acerca_link_2: "Careers",
		acerca_link_3: "News",
		acerca_link_4: "Succes Stories",
		recursos_title: "Resources and Contact:",
		recursos_link_1: "Support Center",
		recursos_link_2: "Frequently Asked Questions",
		recursos_link_3: "Tutorials",
		recursos_link_4: "Contact",
		servicios_title: "Services for:",
		servicios_link_1: "Industries and Companies",
		servicios_link_2: "Family and Individuals",
		soluciones_title: "Solutions:",
		soluciones_link_1: "G-Evolution",
		soluciones_link_2: "Mobile Apps",
		soluciones_link_3: "IoT Telematics",
		soluciones_link_4: "Services",
		oficinas_title: "Offices:",
		mapa_text: "View map",
		// button_1_text: "REQUEST A DEMO",
		button_2_text: "Support Center",
	},
};

export default language;